import { useMemo } from 'react';
import { generateArrayNumber } from '@lib/utils.ts';
import RoundedButton from '@features/ui/components/calendars/RoundedButton.tsx';

interface Props {
  year: number;
  currentYear: number;
  minYear: number | null;
  maxYear: number | null;
  clickYear: (data: number) => void;
}

export const Years = (props: Props) => {
  const { year, currentYear, minYear, maxYear, clickYear } = props;

  const date = useMemo(() => {
    return {
      start: year,
      end: year + 11,
    };
  }, [year]);

  return (
    <div className="w-full grid grid-cols-2 gap-2 mt-2">
      {generateArrayNumber(date.start, date.end).map((item, index) => (
        <RoundedButton
          key={index}
          active={currentYear === item}
          disabled={
            (maxYear !== null && item > maxYear) ||
            (minYear !== null && item < minYear)
          }
          padding="py-3"
          onClick={() => {
            clickYear(item);
          }}
        >
          <>{item}</>
        </RoundedButton>
      ))}
    </div>
  );
};
